export default __webpack_public_path__ + "static/media/m5.63ab698a.svg";